import BreadCrumb from '../../components/template/BreadCrumb';
import Header from '../../components/template/Header';
import { PAGE_TITLE } from '../../shared/enums/facebook_ads_reports_enum';
import FacebookAdsTabs from './_components/FacebookAdsTabs';

const AllFacebookAdsReports = () => {
  return (
    <div className='pace-done'>
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_TITLE || 'Facebook Ads Reports'}
          mainLinkTitle='Dashboard'
          mainLinkUrl='/dashboard'
          activeLink={PAGE_TITLE || 'Facebook Ads Reports'}
        />

        <FacebookAdsTabs />
      </div>
    </div>
  );
};

export default AllFacebookAdsReports;
